// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4b14b34f","453":"64be14b1","455":"c60fe5fc","487":"c38b5fbd","568":"88f5578b","877":"0d6cfa29"}[chunkId] + ".chunk.js";
};